import posthog from 'posthog-js';

// The next login on this browser may be a different user; without a reset
// PostHog refuses the merge and pre-login events land on the previous person.
export const resetPosthogIdentity = () => {
  if (posthog.__loaded) {
    posthog.reset();
  }
};
